<template>
  <div v-if="step && step.currentStep" class="bg-white py-1.5 shadow-md flex items-center w-full">
    <!-- <p 
      class="text-center text-xs space-x-3"
      :style="{color: props?.bgColor}"
    >
      <span>{{$t('stepProgress.title')}}</span>
      <span>{{step?.currentStep}} / 3</span>
    </p> -->

    <div class="grid grid-cols-3 gap-0.5 px-16 py-0.5 w-full mx-auto">
      <div class="h-3 rounded-l-full bg-gray-200" :style="step?.currentStep >= 1 ? `background-color: ${props?.bgColor}`  : ''"></div>
      <div class="h-3 bg-gray-200" :style="step?.currentStep >= 2 ? `background-color: ${props?.bgColor}`  : '' "></div>
      <div class="h-3 rounded-r-full bg-gray-200" :style="step?.currentStep >= 3 ? `background-color: ${props?.bgColor}`  : '' "></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps({
    step: { type: Object, default: {} },
    bgColor: { type: String, default: "#0855cb"},
  })


</script>

<style scoped>

</style>